import { useCollection, useIO, useLinked, useModel } from "@type-r/react";
import { Loading } from "lqx-react";
import React from "react";
import { getUserDetail } from "src/app/services/can";
import { appConfig } from "../../api/appConfig";
import { AssetType } from "../../api/assetType";
import { Company } from "../../api/company";
import { DocumentSource } from "../../api/documentSource";
import { IngestionJob } from "../../api/ingestionJob";
import { ImportTemplatesLookup } from "../../api/lookups";
import { ManualPayment } from "../../api/manualPayment";
import { AddAssetsStep } from "../add-assets-step";
import { PaymentForm } from "./payment-form";

export const AddPaymentsStep = ({ next, back, cancel, job }:
  { next?, back?, cancel?, job: IngestionJob }) => {
  const assetExtensions = "*.xlsx,*.xls,*.csv,*.pdf,*.tif";

  const showDownloadTemplate = true;
  const $dataHolderId = useLinked<Company>(new Company());
  const userTemplates = useModel(ImportTemplatesLookup);
  const $allowedExtension = useLinked(assetExtensions);
  const $userTemplate = useLinked<{ id?: string }>(null)
    .onChange(x => applyImportTemplateExtension(x.id));

  //TODO we removed organizationId bacause organizationId from INBLOCK
  //const $organizationId = useLinked(localUserInfo.organization_id);

  const isReady = useIO(async () => {
    const params = { params: { assetTypeId: AssetType.payment } }
    await userTemplates.fetch(params).catch(e => console.error(e));
  }, []);

  const applyImportTemplateExtension = (userTemplateId) => {
    let importTemplateExtension: string;
    if (Boolean(userTemplateId) && Boolean(userTemplates)) {
      const userTemplate = userTemplates.items.find((item) => item.id === userTemplateId);
      if (userTemplate) {
        importTemplateExtension = userTemplate.originalFileName.split(".").pop();
        $allowedExtension.set(`*.${importTemplateExtension}`);
      }
    } else {
      $allowedExtension.set(assetExtensions);
    }
  }

  return isReady ?
    <>
      <AddAssetsStep
        manualAssetModel={ManualPayment}
        assetName="Payment"
        allowedExtension={$allowedExtension.value}
        $dataHolderId={$dataHolderId}
        userTemplates={userTemplates}
        $userTemplate={$userTemplate}
        jobInfoProvider={() => ({ ...DocumentSource.Payment, dataHolderId: Boolean($dataHolderId.value) ? $dataHolderId.value.id : null, userTemplateId: $userTemplate.value.id })}
        showDownloadTemplate={showDownloadTemplate}
        assetForm={manualPayment => appConfig.allowManualPaymentCreation ? <PaymentForm payment={manualPayment}></PaymentForm> : null}
        next={next} back={back} cancel={cancel} job={job} />
    </> : <Loading />
};
